import GradientStop from './gradient-stop';

/**
 * Represents a linear gradient
 */
export default class LinearGradient {
  x1 = 0;
  y1 = 0;
  x2 = 100;
  y2 = 100;
  /**
   * @type GradientStop[]
   */
  stops = [];

  /**
   *
   * @param {SVGLinearGradientElement|undefined} element
   */
  constructor (element) {
    if (element) {
      this.parseElement(element);
    } else {
      const stop1 = new GradientStop();
      const stop2 = new GradientStop();
      stop2.offset = 100;
      stop2.color = '#87CEEB'; // skyblue
      this.stops = [stop1, stop2];
    }
  }

  /**
   *
   * @param {SVGLinearGradientElement} element
   */
  parseElement (element) {
    const me = this;
    ['x1', 'y1', 'x2', 'y2'].forEach(attribute => {
      me[attribute] = parseFloat(element.getAttribute(attribute)) || 0;
    });

    this.stops = [];
    const stopElements = element.querySelectorAll('stop');
    stopElements.forEach(stopElement => {
      this.stops.push(new GradientStop(stopElement));
    });
  }

  /**
   * Copy current object to this element (stops must be copied separately)
   * @param {SVGLinearGradientElement} linearGradientElement
   */
  toElement (linearGradientElement) {
    const me = this;
    ['x1', 'y1', 'x2', 'y2'].forEach(attribute => {
      linearGradientElement.setAttribute(attribute, me[attribute] + '%');
    });
  }
}
